import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import '../styles/ImageSelector.css'

const ImageSelector = ({matrixId, setMatrixId, imageSrc, setImageSrc, setImgProp, imgBlindType, setImgBlindType}) => {

  const handleMatrixId = (e) => {
    const selectIndex = e.target.selectedIndex
    const selectOption = e.target.options[selectIndex]
    const selectedId = selectOption.id
    setMatrixId(selectedId)
  }

  // FileReader API
  const handleImageUpload = (e) => {
    const img = e.target.files[0]

    if (!img) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const imageDataUrl = e.target.result

      const imgCopy = new Image()
      imgCopy.src = imageDataUrl

      imgCopy.onload = () => {
        
        setImgProp([imgCopy.naturalWidth, imgCopy.naturalHeight])
      }
      setImageSrc(imageDataUrl)
    }

    reader.readAsDataURL(img)
  }

  return (
    <div className='img-selector-page'>
      <nav className='color-blindness-nav'>
        <ul>
          <NavLink to='/' className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}>Color Picker</NavLink>
          <NavLink to='/image-selector' className={({isActive}) => `navlink link ${isActive ? 'active' : ''}`}>Image Selector</NavLink>
        </ul>
      </nav>
      <main>
        <input 
          type="file" 
          name="select-image" 
          id="select-image" 
          accept='image/'
          onChange={handleImageUpload}
        />
        {imageSrc && <div className='image-container'>
          <img src={imageSrc} alt='Preview of uploaded file' className='display-image'/>
        </div>}
        {imageSrc && 
          <select 
            name="pick-color-blind" 
            id={matrixId} 
            value={imgBlindType}
            onChange={(e) => {
              handleMatrixId(e)
              setImgBlindType(e.target.value)
            }}>
            <option value="PROTANOPIA" id='0'>Protanopia - Red Cone Deficiency</option>
            <option value="DEUTERANOPIA" id='1'>Deuteranopia - Green Cone Deficiency</option>
            <option value="TRITANOPIA" id='2'>Tritanopia - Blue Cone Deficiency</option>
            <option value="ACHROMATOPSIA" id='3'>Achromatopsia - Grayscale</option>
            <option value="PROTANOMALY" id='4'>Protanomaly - Weak Red Cone</option>
            <option value="DEUTERANOMALY" id='5'>Deuteranomaly - Weak Green Cone</option>
            <option value="TRITANOMALY" id='6'>Tritanomaly - Weak Blue/Yellow Cone</option>
            <option value="MONOCHROMACY" id='7'>Monochromacy - Only Blue Functional</option>
          </select>}
        {imageSrc && 
        <Link to='/simulated-image-page'>
          <button>Simulate Color Blindness</button>
        </Link>}
      </main>
    </div>
  )
}

export default ImageSelector